export enum Position {
  QB = 'QB',
  RB = 'RB',
  WR = 'WR',
  OL = 'OL',
  DL = 'DL',
  LB = 'LB',
  DB = 'DB',
  K = 'K',
}
